export default __webpack_public_path__ + "img/8b3eebdfd497dfb37b4aba401d047b58.svg";